import { usePrivateFilePreview } from "@/hooks/use-private-file-preview.hook.ts";
import { UseDocumentPreviewStateParams } from "@/pages/employees/employee/widgets/use-document-preview-state.hook.ts";
import { STRETCH_MODAL_CONTENT_VIEWPORT_OFFSET_PX } from "@/constants/ui/stretch-modal-content.constants";
import analyticsService from "@/services/analytics-service.ts";
import { DocumentPreviewModal, ModalProps } from "@skailer-com/uikit";
import { useCallback, useEffect } from "react";

export interface PrivateFilePreviewAnalytics {
  viewed: string;
  downloaded: string;
  properties: Record<string, string | number | boolean | undefined>;
}

export interface PrivateFilePreviewModalProps extends ModalProps, UseDocumentPreviewStateParams {
  analytics: PrivateFilePreviewAnalytics;
}

export function PrivateFilePreviewModal({
  file,
  preview,
  refetchPreview,
  analytics,
  ...props
}: PrivateFilePreviewModalProps) {
  const onDownloaded = useCallback(() => {
    analyticsService.trackEvent(analytics.downloaded, analytics.properties);
  }, [analytics]);
  const { previewUrl, sourceFile, status, isLoading, isDownloading, handleDownload } =
    usePrivateFilePreview({ file, preview, refetchPreview, onDownloaded });

  useEffect(() => {
    analyticsService.trackEvent(analytics.viewed, analytics.properties);
  }, [analytics, file.uuid]);

  return (
    <DocumentPreviewModal
      {...props}
      previewUrl={previewUrl}
      contentType={sourceFile?.mime_type ?? null}
      fileName={file.name}
      status={status}
      isLoading={isLoading}
      isDownloading={isDownloading}
      contentOffsetPx={STRETCH_MODAL_CONTENT_VIEWPORT_OFFSET_PX}
      onDownload={() => {
        void handleDownload();
      }}
      onOpenInNewTab={() => {
        if (previewUrl) window.open(previewUrl, "_blank", "noopener,noreferrer");
      }}
    />
  );
}
